module.exports = __webpack_public_path__ + "static/media/banane.85989c7f.svg";